export class Customer {
    custId: string = '';
    custName: string = "";
}